<template>
    <div>
        <header-portrate />
    <div class="m-2">
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" style="margin-top:60px !important;" />
        <!-- <v-row class="m-2">
            <v-col cols="12" md="12" sm="12" class="text-end">
                <b-button variant="success" style="width:145px;" class="btn-sm" @click="addnew({id:0})" v-b-toggle.add_category>{{lang.add}}</b-button>
            </v-col>
        </v-row> -->
        <v-row class="m-2">
            <v-col cols="12">

            </v-col>
        </v-row>
        <vue-snotify></vue-snotify>
        <products-addcats ref="AddCategory" />
    </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import ProductsAddcats from '@/components/products-addcats.vue';
import Footer from '@/components/Footer.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue'
export default{
  components: { breadCrumbs, TabsComp, ProductsAddcats,Footer,HeaderPortrate },
    name: 'Products',
    data() {
        return {
            active_tab:0,
            fieldRules: [
                v => !!v || 'الحقل مطلوب',
            ],
            product_categories: [],
        }
    },
    created() {
        //this.getCats();
    },
    methods: {
        delItem(item) {
            const post = new FormData();
            post.append("type","DelCats");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',item.id);
            post.append('data[lang]',this.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                this.getCats();
            });
        },
        addnew(item){
            if(item.id == 0){
                this.$refs.AddCategory.namear = '';
                this.$refs.AddCategory.nameen = '';
                this.$refs.AddCategory.parentid = 0;
                this.$refs.AddCategory.changeType(1);
                this.$refs.AddCategory.id = 0;
            }else{
                this.$refs.AddCategory.namear = item.namear;
                this.$refs.AddCategory.nameen = item.nameen;
                this.$refs.AddCategory.parentid = item.parentid == 0 ? 0 : item.parentid;
                this.$refs.AddCategory.changeType(item.type == 0 ? 0 : 1);
                this.$refs.AddCategory.id = item.id;
            }
        },
        getCats(){
            const post = new FormData();
            post.append("type","getPCats");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',"all");
            post.append('data[lang]',this.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                const p = res.data;
                // // console.log(p);
                let t = [];
                if(typeof p.results !== 'undefined' && typeof p.results.data !== 'undefined'){
                    if(p.results.data.length != 0){
                        for(let i=0;i<p.results.data.length;i++){
                            t.push(p.results.data[i]);
                        }
                    }
                }
                this.product_categories = t;
            });
        },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        headers: function(){
            return [
                {
                    text: this.lang.category_name_ar,
                    align: 'center',
                    filterable: false,
                    value: 'namear',
                },
                {
                    text: this.lang.category_name_en,
                    align: 'center',
                    filterable: false,
                    value: 'nameen',
                },
                {
                    text: this.lang.category_type,
                    align: 'center',
                    filterable: false,
                    value: 'type',
                },
                {
                    text: this.lang.category_parent,
                    align: 'center',
                    filterable: false,
                    value: 'parentid',
                },
                {
                    text: this.lang.subcat_count,
                    align: 'center',
                    filterable: false,
                    value: 'subcat_count',
                },
                {
                    text: this.lang.products,
                    align: 'center',
                    filterable: false,
                    value: 'products',
                },
                {
                    text: this.lang.action,
                    align: 'center',
                    filterable: false,
                    value: '',
                },
            ]
        },
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
        },
        items: function() {
            return {
                    text: this.lang.product_categories,
                    disabled: true,
                    to: '/inventory/products',
                }
        }
    },
}
</script>